<script>
import VBaseCard from "@/components/commonComponents/VBaseCard.vue";
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import QuotesModal from "@/components/Quotes/QuotesModal.vue";
import ComponentsKeys from "@/mixins/ComponentsKeys";
import roscongressUrl from "@/utils/roscongressUrl";

export default {
    name: "VCardActivity",
    mixins: [
        ComponentsKeys,
    ],
    components: {
        QuotesModal,
        AjaxLoad,
        VBaseCard,
        DocumentSettings: () => import('@/components/Document/DocumentSettings'),
    },
    props: {
        reloadInterval: {
            type: Number,
            default: 30,
        },
    },
    data() {
        return {
            idProject: null,
            idForumsBitrix: null,
            idEventsBitrix: null,
            componentsKeys: {
                quotesModal: this.getRandomKey('quotesModal'),
                documentSettings: this.getRandomKey('documentSettings'),
            },
            ajaxIntervalId: null,
        };
    },
    mounted() {
        if (this.reloadInterval) {
            this.ajaxIntervalId = setInterval(this.$refs.ajax.load, this.reloadInterval * 1000);
        }
    },
    beforeDestroy() {
        if (this.ajaxIntervalId) {
            clearInterval(this.ajaxIntervalId);
        }
    },
    methods: {
        getSourceName(item) {
            const sources = {
                comments: 'Комментарий',
                digests: 'Дайджест',
                sessions: 'Сессия',
                approves: 'Изменение состояния',
            };
            return sources[item.source] || item.source;
        },
        getActionName(item) {
            const actions = {
                'new': 'Добавлено',
                'published': 'Опубликовано на Портале',
                'approver.declined': 'Отклонено',
                'moderator.declined': 'Отклонено',
                'editor.approved': 'Предложено к публикации',
                'approver.approved': 'Отправлено на утверждение',
                'moderator.approved': 'Одобрено',
            }
            return actions[item.action] || item.action;
        },
        reload() {
            this.$refs.ajax.load();
        },
        onClickItemQuote(item) {
            this.idProject = item.id_project;
            this.idForumsBitrix = item.id_forums_bitrix || 0;
            this.idEventsBitrix = item.id_events_bitrix;
            this.$nextTick(() => {
                this.$refs.quotesModal.show(item.pk)
                    .catch(this.notifyError)
                    .finally(() => {
                        this.updateComponentKey('quotesModal');
                    });
            });
        },
        onClickItemReport(item) {
            this.idProject = item.id_project;
            setTimeout(() => {
                this.$refs.documentSettings?.show(item.pk)
                    .catch(this.notifyError)
                    .finally(() => {
                        this.updateComponentKey('documentSettings');
                        this.reload();
                    });
            }, 100);
        },
        onClickItem(item) {
            if (item.table === 'quotes') {
                this.onClickItemQuote(item);
            }else if (item.table === 'reports') {
                this.onClickItemReport(item);
            }
        },
        getItemEventLogo(item) {
            return roscongressUrl.getUploadedUrl(item.event_logo);
        },
        getEventRoute(item) {
            return {
                name: 'ForumEvent',
                params: {
                    ID_FORUM: item.id_forums_bitrix || 0,
                    ID_EVENT: item.id_events_bitrix,
                    ID_SESSION: item.pk,
                },
            };
        },
        getItemRoute(item) {
            if (item.table === 'sessions') {
                return item.id_session_bitrix && {
                    name: 'ForumEventSession',
                    params: {
                        ID_FORUM: item.id_forums_bitrix || 0,
                        ID_EVENT: item.id_events_bitrix,
                        ID_SESSION: item.id_session_bitrix,
                    },
                };
            } else if (item.table === 'digests') {
                return {
                    name: 'ForumEventDigestsItem',
                    params: {
                        ID_FORUM: item.id_forums_bitrix || 0,
                        ID_EVENT: item.id_events_bitrix,
                        ID_DIGESTS: item.pk,
                    },
                };
            } else if (item.table === 'wordclouds') {
                return {
                    name: 'ForumEventWordCloud',
                    params: {
                        ID_FORUM: item.id_forums_bitrix || 0,
                        ID_EVENT: item.id_events_bitrix,
                        ID_WORDCLOUDS: item.pk,
                    },
                };
            }
            return undefined;
        }
    },
}
</script>

<template>
    <ajax-load
        ref="ajax"
        :url="$apiUrl.getWidgetActivityUrl()"
        :transform="response => _.orderBy(response.data.data, 'updated_at', 'desc')"
        v-slot="{resolved, data}"
    >
        <v-base-card
            :loading="!resolved"
            heading="Лента активности"
            hide-filter
            hide-search
            class="fill-height"
        >
            <v-card-text>
                <v-timeline reverse>
                    <v-timeline-item v-for="(item, index) in data" :key="index" large>
                        <template v-slot:icon>
                            <router-link :to="getEventRoute(item)">
                                <v-avatar>
                                    <img :src="getItemEventLogo(item)"/>
                                </v-avatar>
                            </router-link>
                        </template>
                        <template v-slot:opposite>
                            <div class="activity-source-event">{{ item.event_name }}</div>
                            <div class="activity-source-date">{{ item.updated_at | moment('DD.MM.Y HH:mm:ss') }}</div>
                            <div class="activity-source-author" v-if="item.updated_by_name">{{
                                    item.updated_by_name
                                }}
                            </div>
                        </template>
                        <v-card
                            @click="onClickItem(item)"
                            :to="getItemRoute(item)"
                            class="elevation-2"
                            :class="{
                                'activity-success': ['moderator.approved', 'published'].includes(item.action),
                                'activity-warning': ['editor.approved', 'approver.approved'].includes(item.action)
                                        || (['sessions', 'wordclouds'].includes(item.source) && item.action === 'new'),
                                'activity-error': ['moderator.declined', 'approver.declined'].includes(item.action)
}"
                        >
                            <v-card-title>
                                <template v-if="item.source === 'comments' && item.action === 'new'">
                                    Новый комментарий
                                </template>
                                <template v-else-if="item.source === 'approves'">
                                    {{ getActionName(item) }}
                                </template>
                                <template v-else-if="item.action === 'published'">
                                    {{ getActionName(item) }}
                                </template>
                                <template
                                    v-else-if="['sessions', 'wordclouds'].includes(item.source)  && item.action === 'new'">
                                    Новые данные из генеративной системы
                                </template>
                                <template v-else>
                                    {{ getSourceName(item) }}
                                </template>
                            </v-card-title>
                            <v-card-text class="activity-text">
                                <template v-if="item.table === 'digests'">
                                    <span class="activity-entity-name">Дайджест</span>
                                </template>
                                <template v-else-if="item.table === 'reports'">
                                    <span class="activity-entity-name">Итоги дня</span>
                                </template>
                                <template v-if="item.table === 'quotes'">
                                    <span class="activity-entity-name">{{ `Цитата #${item.pk} из сессии` }}</span>
                                </template>
                                <template v-else-if="item.table === 'wordclouds'">
                                    <span class="activity-entity-name">Облако смыслов</span>
                                </template>
                                <template v-else-if="item.table === 'sessions'">
                                    <span class="activity-entity-name">Сессия</span>
                                </template>
                                &laquo;{{ item.title }}&raquo;
                            </v-card-text>
                        </v-card>
                    </v-timeline-item>
                </v-timeline>

                <quotes-modal
                    v-if="idProject"
                    ref="quotesModal"
                    :key="componentsKeys.quotesModal"
                    :id-project="idProject"
                    :id-forums-bitrix="idForumsBitrix"
                    :id-events-bitrix="idEventsBitrix"
                ></quotes-modal>

                <document-settings 
                    v-if="idProject"
                    :key="componentsKeys.documentSettings"  
                    :draggable="false" 
                    :projectId="idProject"  
                    ref="documentSettings"
                ></document-settings>
            </v-card-text>
        </v-base-card>
    </ajax-load>
</template>

<style scoped lang="scss">
::v-deep {
    .v-timeline {
        padding-top: 0;

        .v-timeline-item {
            padding-bottom: 16px;

            .v-timeline-item__body {
                .elevation-2 {
                    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 20px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
                }
            }

            .v-card {
                .v-card__title {
                    padding-top: 8px;
                    padding-bottom: 4px;
                    font-size: 1rem;
                    line-height: 1.5rem;
                }

                &.activity-success {
                    .v-card__title {
                        color: darkgreen;
                    }

                    border-bottom: 3px solid green;
                }

                &.activity-warning {
                    .v-card__title {
                        color: #b56808;
                    }

                    border-bottom: 3px solid darkorange;
                }

                &.activity-error {
                    .v-card__title {
                        color: darkred;
                    }

                    border-bottom: 3px solid red;
                }
            }

            .v-card__text {
                padding-bottom: 8px;
            }

            .activity-entity-name {
                opacity: 0.7;
            }
        }

        .v-timeline-item__opposite {
            color: rgba(0, 0, 0, 0.55);
            font-size: 12px;
            line-height: 14px;

            .activity-source-event {
                font-weight: 500;
            }

            /*
            .activity-source-date {
            }
            */

            /*
            .activity-source-author {
            }
            */
        }
    }

}
</style>
